import React from "react";
import GenericEditForm from "../../components/GenericEditForm";

function EditPresentation() {
  return (
    <GenericEditForm
      title="Presentacion"
      endpoint="/presentations"
      backTo="/presentations"
      fields={[
        {
          name: "name",
          label: "Nombre",
          type: "text",
          placeholder: "Nombre de la presentacion",
          required: true,
        },
        {
          name: "description",
          label: "Descripción",
          type: "textarea",
          placeholder: "Descripción de la presentacion",
          required: false,
        },
      ]}
    />
  );
}

export default EditPresentation;
